import { render, staticRenderFns } from "./LearningResources.vue?vue&type=template&id=f65c6642&scoped=true&"
import script from "./LearningResources.vue?vue&type=script&lang=ts&"
export * from "./LearningResources.vue?vue&type=script&lang=ts&"
import style0 from "./LearningResources.vue?vue&type=style&index=0&id=f65c6642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65c6642",
  null
  
)

export default component.exports